import React, { FC } from 'react';

import AgeCategorySelector from '../common/AgeCategorySelector';
import TitleDropdown from './TitleDropdown';
import LoanFormatDropDown from './LoanFormatDropDown';
import SubNavigationLayout from './SubNavigationLayout';
import { LinkContainer } from './NavigationLinksContainer';
import { NavigationLink } from './NavigationLink';
import './ForeignLanguageNavigation.scss';
import { useTranslation } from 'react-i18next';
import { useAgeCategorySearchParam } from '../utils/useAgeCategorySearchParam';
import { useLoanFormat } from '../../app-store/loanFormat/useLoanFormat';

type Props = {
    readonly isSticky: boolean;
};

const ForeignLanguageNavigation: FC<Props> = ({ isSticky }) => {
    const { t } = useTranslation();
    const { loanFormat } = useLoanFormat();
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});

    const loanFormatKey = loanFormat?.key ?? 'all';
    const lowerLoanFormat = loanFormatKey.toLowerCase();

    return (
        <SubNavigationLayout
            className="foreign-language-nav"
            left={<TitleDropdown loanFormat={undefined} isForeignLanguage />}
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink
                            to={{
                                pathname: `/language/lote/${lowerLoanFormat}`,
                                search: searchParams.toString()
                            }}
                            alternativeRoutes={['/language/lote']}
                        >
                            {t('menu.shop.languages.lote')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink
                            to={{
                                pathname: `/language/languagelearning/${lowerLoanFormat}`,
                                search: searchParams.toString()
                            }}
                            alternativeRoutes={['/language/languagelearning']}
                        >
                            {t('menu.shop.languages.languageLearning')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink
                            to={{
                                pathname: `/language/bundles/${lowerLoanFormat}`,
                                search: searchParams.toString()
                            }}
                            alternativeRoutes={['/language/bundles']}
                        >
                            {t('menu.shop.languages.curatedCollections')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={
                !isSticky ? (
                    <div className="dropdown-container">
                        <LoanFormatDropDown showIcons={false} />
                        <AgeCategorySelector />
                    </div>
                ) : null
            }
            isSticky={isSticky}
            width="30"
        />
    );
};

export default ForeignLanguageNavigation;
